import React, { useEffect, useState } from "react";
import { GraduationCap } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";
import { EmployeeScorecard } from "../EmployeeScorecard";
import { CoachingCard } from "../ai";
import ResponsesSummary from "../ResponsesSummary";
import { Label } from "../common";
import { Button } from "../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export default function EmployeePerformanceTab({ cv, employeeId }) {
  const [modules, setModules] = useState([]);
  const [assignMod, setAssignMod] = useState("");

  useEffect(() => {
    api.get("/training/modules").then((r) => setModules(r.data)).catch((e) => console.warn("Training modules load failed", e));
  }, []);

  const assign = async () => {
    if (!assignMod) return;
    await api.post("/training/assignments", { employee_id: employeeId, module_id: assignMod });
    toast.success("Training assigned");
    setAssignMod("");
  };

  return (
    <div className="space-y-6">
      <EmployeeScorecard employeeId={employeeId} />
      <ResponsesSummary employeeId={employeeId} days={30} title="Rating detail · last 30 days" testId="employee-responses-summary" />
      <CoachingCard employeeId={employeeId} />
      <div className="rounded-xl border border-slate-200 bg-white p-6" data-testid="assign-training-card">
        <Label>Assign Training</Label>
        <div className="mt-4 flex flex-wrap items-end gap-3">
          <div className="min-w-[260px] flex-1">
            <Select value={assignMod} onValueChange={setAssignMod}>
              <SelectTrigger data-testid="assign-module"><SelectValue placeholder="Choose a module" /></SelectTrigger>
              <SelectContent>{modules.map((m) => <SelectItem key={m.id} value={m.id}>{m.title} · {m.duration_min}m</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <Button onClick={assign} disabled={!assignMod} data-testid="assign-training" className="bg-[#4338CA] hover:bg-[#3730A3]">
            <GraduationCap className="mr-1 h-4 w-4" /> Assign
          </Button>
        </div>
        {cv?.gap && (
          <p className="mt-4 text-sm text-slate-500">Recommended for this employee: <span className="font-semibold text-indigo-700">{cv.gap.recommended_training}</span></p>
        )}
      </div>
    </div>
  );
}
